import React from 'react'
import assets from '../assets'

const Logo = ({ big, light }) => {
  const link = light ? assets.masdarLogoLight : assets.masdarLogoDark
  return (
    <img
      src={link}
      height={big ? '100px' : '40px'}
      style={{
        margin: '0px auto'
      }}
      alt='Buzzin'
    />
  )
}

export default Logo
